import { NgModule } from '@angular/core';

import { AccordionHeaderComponent } from './accordion-header.component';
import { AccordionPanelComponent } from './accordion-panel.component';
import { AccordionComponent } from './accordion.component';

@NgModule({
  imports: [AccordionComponent, AccordionPanelComponent, AccordionHeaderComponent],
  exports: [AccordionComponent, AccordionPanelComponent, AccordionHeaderComponent],
})
export class AccordionModule {}
